/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateOrganizationUserSessionIssuerForm,
  CreateOrganizationUserSessionIssuerForm$Outbound,
  CreateOrganizationUserSessionIssuerForm$outboundSchema,
} from "../components/createorganizationusersessionissuerform.js";

export type CreateOrganizationUserSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateOrganizationUserSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createOrganizationUserSessionIssuerForm:
    CreateOrganizationUserSessionIssuerForm;
};

/** @internal */
export type CreateOrganizationUserSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateOrganizationUserSessionIssuerSecurity$outboundSchema:
  z.ZodMiniType<
    CreateOrganizationUserSessionIssuerSecurity$Outbound,
    CreateOrganizationUserSessionIssuerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createOrganizationUserSessionIssuerSecurityToJSON(
  createOrganizationUserSessionIssuerSecurity:
    CreateOrganizationUserSessionIssuerSecurity,
): string {
  return JSON.stringify(
    CreateOrganizationUserSessionIssuerSecurity$outboundSchema.parse(
      createOrganizationUserSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type CreateOrganizationUserSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreateOrganizationUserSessionIssuerForm:
    CreateOrganizationUserSessionIssuerForm$Outbound;
};

/** @internal */
export const CreateOrganizationUserSessionIssuerRequest$outboundSchema:
  z.ZodMiniType<
    CreateOrganizationUserSessionIssuerRequest$Outbound,
    CreateOrganizationUserSessionIssuerRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      createOrganizationUserSessionIssuerForm:
        CreateOrganizationUserSessionIssuerForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        createOrganizationUserSessionIssuerForm:
          "CreateOrganizationUserSessionIssuerForm",
      });
    }),
  );

export function createOrganizationUserSessionIssuerRequestToJSON(
  createOrganizationUserSessionIssuerRequest:
    CreateOrganizationUserSessionIssuerRequest,
): string {
  return JSON.stringify(
    CreateOrganizationUserSessionIssuerRequest$outboundSchema.parse(
      createOrganizationUserSessionIssuerRequest,
    ),
  );
}
